import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 0A06A44E-09F4-491E-B221-24E401CA3DDB
 * name information-slab-circle-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-circle-outline.svg
 * tags
 * - Settings 
 */
export const InformationSlabCircleOutlineIcon = createSvgIcon(<><path d="M11 7V9H13V7H11M14 17V15H13V11H10V13H11V15H10V17H14M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12M20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12Z" /></>, 'InformationSlabCircleOutlineIcon');
export default InformationSlabCircleOutlineIcon